import React from "react";
import "../../App.css";
import Cards from "../Cards";

function Petwo() {
  return (
    <>
      <div className="pe02">
        <img src="images/img-14.jpg" width="100%" height="auto" alt="" />
      </div>
      <Cards />
    </>
  );
}

export default Petwo;
